import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css, withTheme } from 'styled-components';

import { ButtonOutlined, Text, Radio, Flex, Box, Checkbox, SvgIcon } from 'Components/Base';
import { COLOR } from 'Components/Theme';
import HTMLView from 'Components/HTMLView';

import { EXAM_TYPE } from '../../../Exam/constant';

export const CHOICE_STATUS = {
  NORMAL: 'NORMAL',
  PASSED: 'PASSED',
  FAIL: 'FAIL',
  NOT_SELECTED: 'NOT_SELECTED',
};

export const CHOICE_TYPE = {
  ...EXAM_TYPE,
  PASS: 'PASSED',
  FAIL: 'FAILED',
  NONE: 'NONE',
};

const BOX_COLOR = COLOR.greyscale.grey5;

const CHOICE_COLOR = {
  [CHOICE_STATUS.NORMAL]: 'blacks.3',
  [CHOICE_STATUS.PASSED]: 'success',
  [CHOICE_STATUS.FAIL]: 'danger',
  [CHOICE_STATUS.NOT_SELECTED]: 'success',
};
const ChoiceButton = styled(({ normal, checked, ...restProps }) => (
  <ButtonOutlined width={1} py={2} {...restProps} />
))`
  text-align: left;
  ${(props) =>
    props.checked &&
    css`
      box-shadow: 0px 0px 0px 1px inset !important;
      border-color: ${BOX_COLOR};
    `};
  ${(props) =>
    props.notSelected &&
    css`
      /* todo: use this color from theme (currently does not exist) */
      border-color: #e5e5e5;
    `};
  ${({ normal, checked }) =>
    normal &&
    checked &&
    css`
      background-color: ${BOX_COLOR};
      box-shadow: none !important;
      &:hover {
        background-color: ${BOX_COLOR};
        border-color: ${BOX_COLOR};
      }
    `};
`;

const AnswerWrapper = styled(Text)`
  * {
    line-height: 1.75;
  }
  p:first-child {
    margin-top: 0;
  }
  p:last-child {
    margin-bottom: 0;
  }
`;

class Choice extends Component {
  static propTypes = {
    checked: PropTypes.bool,
    status: PropTypes.oneOf(Object.values(CHOICE_STATUS)),
    title: PropTypes.string,
    type: PropTypes.string,
  };

  static defaultProps = {
    status: CHOICE_STATUS.NORMAL,
    title: 'title',
  };

  renderChoiceType() {
    const { theme, type, checked } = this.props;
    switch (type) {
      case CHOICE_TYPE.MULTIPLE_SELECTION:
        return <Checkbox checkedColor={theme.colors.primary} checked={checked} />;
      case CHOICE_TYPE.SINGLE_SELECTION:
        return (
          <Radio name="action" checkedColor={theme.colors.primary} checked={checked} mt="-1px" />
        );
      default:
        return <Box width={22} />;
    }
  }
  render() {
    const { title, status, type, checked, ...restProps } = this.props;
    return (
      <ChoiceButton
        outline
        checked={checked}
        normal={status === CHOICE_STATUS.NORMAL}
        notSelected={status === CHOICE_STATUS.NOT_SELECTED}
        color={CHOICE_COLOR[CHOICE_STATUS[status]]}
        {...restProps}
      >
        <Flex>
          <Flex alignItems={'center'} width={9 / 10}>
            <Flex flex={'0 0 auto'} mr={2}>
              {this.renderChoiceType()}
            </Flex>
            <Flex alignItems="center" style={{ whiteSpace: 'normal' }}>
              <AnswerWrapper
                color="quizAnswerDetails"
                lineHeight="loose"
                fontFamily="contentReadable"
              >
                <HTMLView rawContent={title} />
              </AnswerWrapper>
            </Flex>
          </Flex>
          <Flex justifyContent={'flex-end'} width={1 / 10}>
            {status === CHOICE_STATUS.FAIL && (
              <Flex alignItems="center">
                <SvgIcon icon={SvgIcon.ICON_LIST.CLOSE_CIRCLE} size={28} />
              </Flex>
            )}
            {status === CHOICE_STATUS.PASSED && (
              <Flex alignItems="center">
                <SvgIcon icon={SvgIcon.ICON_LIST.CHECK_CIRCLE} size={28} />
              </Flex>
            )}
            {status === CHOICE_STATUS.NOT_SELECTED && (
              <Flex alignItems="center">
                <SvgIcon icon={SvgIcon.ICON_LIST.CHECK_CIRCLE} size={28} />
              </Flex>
            )}
          </Flex>
        </Flex>
      </ChoiceButton>
    );
  }
}

Choice.CHOICE_STATUS = CHOICE_STATUS;

export default withTheme(Choice);
